import { DateTime } from "models/common";

export const sortByAtDescFunc = <T extends { at: DateTime }>(a: T, b: T): number => a.at > b.at ? -1 : a.at < b.at ? 1 : 0;